(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Sticky header shadow */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu */
  var mobileNav = $('#MobileNav');
  $$('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      btn.setAttribute('aria-expanded', 'true');
    });
  });
  $$('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
      $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
  });

  /* Search bar */
  var searchBar = $('#SearchBar');
  $$('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchBar) { window.location.href = '/search'; return; }
      var open = searchBar.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input', searchBar); if (i) i.focus(); }
    });
  });

  /* Reveal on scroll */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Cart count + toast */
  var toast = $('#CartToast');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    $('.toast__text', toast).textContent = text || 'Added to your bag';
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4200);
  }
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
      })
      .catch(function () {});
  }

  /* AJAX add to cart (falls back to normal form post on failure) */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    if (!window.fetch || !window.FormData) return;
    evt.preventDefault();
    var btn = $('[type="submit"]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    fetch(window.Lumina.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || res.data.message || 'Unable to add this item'); return; }
        showToast((res.data.product_title || 'Item') + ' added to your bag');
        return refreshCount();
      })
      .catch(function () { form.removeAttribute('data-ajax-cart'); form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (evt) {
    var b = evt.target.closest('[data-qty]');
    if (!b) return;
    var input = $('input', b.closest('.qty'));
    var v = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit cart quantity changes */
  var cartForm = $('#CartForm');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.name === 'updates[]') { cartForm.submit(); }
    });
  }

  /* Product gallery */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('.gallery__main img', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Variant selection */
  $$('[data-product-form]').forEach(function (wrap) {
    var json = $('[data-product-json]', wrap);
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = $('input[name="id"]', wrap);
    var priceEl = $('[data-price]', wrap);
    var compareEl = $('[data-compare]', wrap);
    var btn = $('[data-add-button]', wrap);
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: wrap.getAttribute('data-currency') || 'USD' });

    function selected() {
      var opts = [];
      $$('[data-option-index]', wrap).forEach(function (group) {
        var checked = $('input:checked', group);
        var select = $('select', group);
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : (select ? select.value : null);
      });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }
    wrap.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      var v = selected();
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt.format(v.price / 100);
      if (compareEl) {
        compareEl.textContent = v.compare_at_price > v.price ? fmt.format(v.compare_at_price / 100) : '';
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Product recommendations */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        var inner = $('[data-recommendations]', div);
        if (inner && inner.innerHTML.trim().length) {
          el.innerHTML = inner.innerHTML;
          $$('.reveal', el).forEach(function (r) { r.classList.add('is-visible'); });
        }
      })
      .catch(function () {});
  });

  /* Collection sort */
  var sort = $('#SortBy');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
